/* MZANZI AUTO — theme.js */
(function () {
  'use strict';

  var money = function (cents) {
    return 'R' + (cents / 100).toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  /* ======================================================================
     LIGHTBOX — shared by product gallery, build gallery, finishes, work
     ====================================================================== */
  var LB = (function () {
    var el = null, items = [], idx = 0;

    function build() {
      el = document.createElement('div');
      el.className = 'lb';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.innerHTML =
        '<button class="lb__x" data-lb-close aria-label="Close">&times;</button>' +
        '<button class="lb__nav lb__nav--prev" data-lb-prev aria-label="Previous"></button>' +
        '<button class="lb__nav lb__nav--next" data-lb-next aria-label="Next"></button>' +
        '<div class="lb__stage" data-lb-stage></div>' +
        '<div class="lb__bar"><span class="mono" data-lb-count></span><span class="mono muted" data-lb-cap></span></div>';
      document.body.appendChild(el);

      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-lb-close]')) return close();
        if (e.target.closest('[data-lb-prev]')) return go(-1);
        if (e.target.closest('[data-lb-next]')) return go(1);
        if (!e.target.closest('.lb__stage > *')) close();
      });

      var x0 = null;
      el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 50) go(dx < 0 ? 1 : -1);
        x0 = null;
      }, { passive: true });
    }

    function paint() {
      var stage = el.querySelector('[data-lb-stage]');
      var it = items[idx];
      if (!it) return;

      if (it.type === 'video') {
        stage.innerHTML = '<video src="' + it.src + '" controls autoplay playsinline></video>';
      } else if (it.type === 'embed') {
        stage.innerHTML = '<div class="lb__embed">' + (it.html || '') + '</div>';
      } else {
        stage.innerHTML = '<img src="' + it.src + '" alt="' + (it.alt || '') + '">';
      }

      el.querySelector('[data-lb-count]').textContent = (idx + 1) + ' / ' + items.length;
      el.querySelector('[data-lb-cap]').textContent = it.caption || '';
      var multi = items.length > 1;
      el.querySelector('[data-lb-prev]').hidden = !multi;
      el.querySelector('[data-lb-next]').hidden = !multi;

      [idx - 1, idx + 1].forEach(function (n) {
        var o = items[(n + items.length) % items.length];
        if (o && o.type === 'image' && o.src) { var p = new Image(); p.src = o.src; }
      });
    }

    function go(step) { idx = (idx + step + items.length) % items.length; paint(); }

    function open(list, start) {
      if (!list || !list.length) return;
      if (!el) build();
      items = list; idx = start || 0;
      paint();
      el.setAttribute('data-open', '');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      if (!el) return;
      el.removeAttribute('data-open');
      el.querySelector('[data-lb-stage]').innerHTML = '';
      document.body.style.overflow = '';
    }

    document.addEventListener('keydown', function (e) {
      if (!el || !el.hasAttribute('data-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') go(-1);
      if (e.key === 'ArrowRight') go(1);
    });

    return { open: open, close: close };
  })();

  window.MZA = window.MZA || {};
  window.MZA.lightbox = LB.open;

  /* ---------- drawers ---------- */
  function bindDrawer(el) {
    if (!el) return;
    var open = function () { el.setAttribute('data-open', ''); document.body.style.overflow = 'hidden'; };
    var close = function () { el.removeAttribute('data-open'); document.body.style.overflow = ''; };
    el.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    el._open = open; el._close = close;
  }

  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var menuDrawer = document.querySelector('[data-menu-drawer]');
  bindDrawer(cartDrawer); bindDrawer(menuDrawer);

  document.querySelectorAll('[data-open-cart]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      if (!cartDrawer) return;
      e.preventDefault(); refreshCart(); cartDrawer._open();
    });
  });
  document.querySelectorAll('[data-open-menu]').forEach(function (b) {
    b.addEventListener('click', function () { if (menuDrawer) menuDrawer._open(); });
  });

  /* ---------- cart ---------- */
  function renderCart(cart) {
    var body = document.querySelector('[data-cart-body]');
    var foot = document.querySelector('[data-cart-total]');
    document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = '<p class="empty mono muted">Nothing in the cart yet.</p>';
      if (foot) foot.textContent = money(0);
      return;
    }
    body.innerHTML = cart.items.map(function (i) {
      return '<div class="cart__row">' +
        '<img src="' + (i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '') + '" alt="" width="88" height="88">' +
        '<div><p class="card__title" style="margin-bottom:6px">' + i.product_title + '</p>' +
        (i.variant_title && i.variant_title !== 'Default Title' ? '<p class="mono muted">' + i.variant_title + '</p>' : '') +
        '<p class="mono" style="margin-top:8px">QTY ' + i.quantity +
        ' &nbsp;<button class="mono" style="color:var(--cobalt-soft);text-decoration:underline" data-remove="' + i.key + '">Remove</button></p></div>' +
        '<span class="price">' + money(i.final_line_price) + '</span></div>';
    }).join('');
    if (foot) foot.textContent = money(cart.total_price);

    body.querySelectorAll('[data-remove]').forEach(function (b) {
      b.addEventListener('click', function () { changeItem(b.getAttribute('data-remove'), 0); });
    });
  }

  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  function changeItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action$="/cart/add"]');
    if (!form || !cartDrawer) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding\u2026'; }

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        if (!res.ok) { alert(res.d.description || 'That variant is unavailable.'); return; }
        refreshCart(); cartDrawer._open();
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } form.submit(); });
  });

  /* ---------- header state ---------- */
  var hdr = document.querySelector('.hdr');
  if (hdr) {
    window.addEventListener('scroll', function () {
      hdr.style.borderBottomColor = window.scrollY > 12 ? 'var(--line-2)' : 'var(--line)';
    }, { passive: true });
  }

  /* ======================================================================
     PRODUCT GALLERY — every slide already in the DOM, so switching is instant
     ====================================================================== */
  document.querySelectorAll('[data-gal]').forEach(function (gal) {
    var slides = Array.prototype.slice.call(gal.querySelectorAll('[data-slide]'));
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-thumb]'));
    var counter = gal.querySelector('[data-gal-count]');
    if (!slides.length) return;
    var i = 0;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === i);
        if (k !== i) {
          var v = s.querySelector('video');
          if (v && !v.paused) v.pause();
        }
      });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      var t = thumbs[i];
      if (t && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }

    gal.querySelectorAll('[data-gal-prev]').forEach(function (b) {
      b.addEventListener('click', function () { show(i - 1); });
    });
    gal.querySelectorAll('[data-gal-next]').forEach(function (b) {
      b.addEventListener('click', function () { show(i + 1); });
    });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });

    gal.setAttribute('tabindex', '-1');
    gal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(i - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(i + 1); }
    });

    var x0 = null;
    gal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    gal.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) show(i + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });

    function collect() {
      var out = [], start = 0;
      slides.forEach(function (s, k) {
        var img = s.querySelector('img[data-full]');
        if (img) {
          if (k === i) start = out.length;
          out.push({ type: 'image', src: img.getAttribute('data-full'), alt: img.alt });
        }
      });
      return { list: out, start: start };
    }
    gal.querySelectorAll('[data-gal-zoom]').forEach(function (b) {
      b.addEventListener('click', function () { var c = collect(); LB.open(c.list, c.start); });
    });
    slides.forEach(function (s) {
      var img = s.querySelector('img[data-full]');
      if (img) img.addEventListener('click', function () { var c = collect(); LB.open(c.list, c.start); });
    });

    show(0);
  });

  /* ---------- generic lightbox groups (build gallery, finishes, work) ---------- */
  document.querySelectorAll('[data-lb-group]').forEach(function (group) {
    var nodes = Array.prototype.slice.call(group.querySelectorAll('[data-lb-item]'));
    var list = nodes.map(function (n) {
      return {
        type: n.getAttribute('data-lb-type') || 'image',
        src: n.getAttribute('data-lb-src') || '',
        html: n.getAttribute('data-lb-html') || '',
        alt: n.getAttribute('data-lb-alt') || '',
        caption: n.getAttribute('data-lb-caption') || ''
      };
    });
    nodes.forEach(function (n, k) {
      n.addEventListener('click', function (e) { e.preventDefault(); LB.open(list, k); });
    });
  });

  /* ---------- variants ---------- */
  document.querySelectorAll('[data-variants]').forEach(function (root) {
    var node = root.querySelector('[data-variant-json]');
    if (!node) return;
    var data = JSON.parse(node.textContent);
    var idField = root.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var btn = root.querySelector('[data-add]');
    var sku = root.querySelector('[data-sku]');
    if (!idField) return;

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('[data-opt]:checked'), function (i) { return i.value; });
    }

    function update() {
      var chosen = selected();
      var match;

      if (chosen.length === 0 && data.length === 1) {
        match = data[0];                       // product uses Shopify's default variant
      } else {
        match = data.find(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        });
      }

      if (!match) { if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; } return; }

      idField.value = match.id;
      if (priceEl) {
        priceEl.innerHTML = match.price === 0
          ? 'Price on request'
          : (match.compare_at_price > match.price ? '<s>' + money(match.compare_at_price) + '</s>' : '') + money(match.price);
      }
      if (sku) sku.textContent = match.sku || '\u2014';

      if (btn) {
        if (match.price === 0) {
          btn.disabled = true; btn.textContent = 'Price on request';
        } else {
          btn.disabled = !match.available;
          btn.innerHTML = match.available ? 'Add to cart <i></i>' : 'Sold out';
        }
      }
      if (history.replaceState) {
        history.replaceState({}, '', window.location.pathname + '?variant=' + match.id);
      }
    }
    root.querySelectorAll('[data-opt]').forEach(function (i) { i.addEventListener('change', update); });
    update();
  });

  /* ---------- quantity ---------- */
  document.querySelectorAll('.qty').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = b.getAttribute('data-step') === 'up' ? 1 : -1;
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
      });
    });
  });

  /* ---------- sort ---------- */
  document.querySelectorAll('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', s.value);
      window.location.href = u.toString();
    });
  });

  /* ---------- finishes picker (wrap / PPF) ---------- */
  document.querySelectorAll('[data-finishes]').forEach(function (root) {
    var out = root.querySelector('[data-finish-selected]');
    root.querySelectorAll('[data-finish]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        root.querySelectorAll('[data-finish]').forEach(function (c) { c.classList.remove('is-on'); });
        chip.classList.add('is-on');
        var name = chip.getAttribute('data-finish');
        var price = chip.getAttribute('data-price') || '';
        if (out) out.innerHTML = '<b>' + name + '</b>' + (price ? ' &middot; ' + price : '');
        var field = document.querySelector('[data-finish-fill]');
        if (field) field.value = name;
      });
    });
  });

  /* ---------- before / after slider ---------- */
  document.querySelectorAll('[data-ba]').forEach(function (ba) {
    var clip = ba.querySelector('[data-ba-clip]');
    var handle = ba.querySelector('[data-ba-handle]');
    var range = ba.querySelector('[data-ba-range]');
    if (!clip || !range) return;

    function set(pct) {
      pct = Math.max(0, Math.min(100, pct));
      clip.style.width = pct + '%';
      if (handle) handle.style.left = pct + '%';
    }
    range.addEventListener('input', function () { set(parseFloat(range.value)); });

    // drag anywhere on the image, not just the invisible range thumb
    var dragging = false;
    function fromEvent(e) {
      var r = ba.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
      var pct = (x / r.width) * 100;
      range.value = pct;
      set(pct);
    }
    ba.addEventListener('mousedown', function (e) { dragging = true; fromEvent(e); });
    window.addEventListener('mousemove', function (e) { if (dragging) fromEvent(e); });
    window.addEventListener('mouseup', function () { dragging = false; });
    ba.addEventListener('touchstart', function (e) { fromEvent(e); }, { passive: true });
    ba.addEventListener('touchmove', function (e) { fromEvent(e); }, { passive: true });

    set(parseFloat(range.value) || 50);
  });

  /* ---------- inline form validation ---------- */
  document.querySelectorAll('form').forEach(function (form) {
    if (!form.querySelector('[required]')) return;

    form.addEventListener('submit', function (e) {
      var bad = null;
      form.querySelectorAll('[required]').forEach(function (f) {
        var wrap = f.closest('.field');
        var ok = f.checkValidity() && String(f.value).trim() !== '';
        if (wrap) {
          wrap.classList.toggle('has-error', !ok);
          if (!ok && !wrap.querySelector('.field__err')) {
            var msg = document.createElement('span');
            msg.className = 'field__err';
            msg.textContent = f.type === 'email'
              ? 'Enter a valid email address'
              : (f.type === 'tel' ? 'Enter a contactable number' : 'This one is required');
            wrap.appendChild(msg);
          }
        }
        if (!ok && !bad) bad = f;
      });
      if (bad) {
        e.preventDefault();
        bad.focus();
        bad.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    });

    form.querySelectorAll('[required]').forEach(function (f) {
      f.addEventListener('blur', function () {
        var wrap = f.closest('.field');
        if (wrap && f.value) wrap.classList.toggle('has-error', !f.checkValidity());
      });
      f.addEventListener('input', function () {
        var wrap = f.closest('.field');
        if (wrap && f.checkValidity()) wrap.classList.remove('has-error');
      });
    });
  });

  /* ---------- prefill enquiry fields from ?product= / ?vehicle= ---------- */
  (function () {
    var qs = new URLSearchParams(window.location.search);
    var prod = qs.get('product');
    var veh = qs.get('vehicle');
    if (prod) {
      var body = document.querySelector('textarea[name="contact[body]"]');
      if (body && !body.value) body.value = 'Enquiry about: ' + prod + '\n\n';
    }
    if (veh) {
      var vf = document.querySelector('[data-garage-fill]');
      if (vf && !vf.value) vf.value = veh;
    }
  })();

  /* ---------- reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('in'); });
  }

  refreshCart();
})();

/* ==========================================================================
   GARAGE — brand › model › generation
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'mza_garage';
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); };
  var slug = function (s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); };

  function saved() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function save(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function clear() { try { localStorage.removeItem(KEY); } catch (e) {} }

  function paintBar() {
    var bar = document.querySelector('[data-garage-bar]');
    if (!bar) return;
    var v = saved();
    if (!v) { bar.hidden = true; return; }
    bar.hidden = false;
    bar.querySelector('[data-garage-label]').innerHTML =
      'Showing fitment for <b>' + esc(v.brand) + ' ' + esc(v.model) + ' ' + esc(v.gen) + '</b>';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-garage-clear]')) { clear(); paintBar(); }
  });
  paintBar();

  var root = document.querySelector('[data-garage]');
  if (!root) return;

  var stage = root.querySelector('[data-garage-stage]');
  var crumb = root.querySelector('[data-garage-crumb]');
  var DATA = null, brand = null, model = null, LOGOS = {};

  /* Tag filtering does NOT work on /collections/all — Shopify ignores the tag.
     It must be a real collection. Falls back to 'parts' if misconfigured. */
  var BASE = root.getAttribute('data-base') || 'parts';
  if (BASE === 'all' || BASE === '') BASE = 'parts';

  var HIDE_EMPTY = root.getAttribute('data-hide-empty') === 'true';
  var ENQUIRY = root.getAttribute('data-enquiry') || '/pages/contact';

  try {
    var ln = root.querySelector('[data-garage-logos]');
    if (ln) LOGOS = JSON.parse(ln.textContent) || {};
  } catch (e) { LOGOS = {}; }

  /* tags that actually exist on products in the base collection */
  var STOCK = {};
  try {
    var tn = root.querySelector('[data-garage-tags]');
    if (tn) {
      (JSON.parse(tn.textContent) || []).forEach(function (t) {
        STOCK[String(t).toLowerCase().trim()] = true;
      });
    }
  } catch (e) { STOCK = {}; }
  var KNOWS_STOCK = Object.keys(STOCK).length > 0;

  function tagOf(g) { return g[2] || slug(g[0]); }
  function hasParts(g) { return !KNOWS_STOCK || !!STOCK[tagOf(g)]; }
  function countFor(list) {
    if (!KNOWS_STOCK) return null;
    return list.reduce(function (n, g) { return n + (STOCK[tagOf(g)] ? 1 : 0); }, 0);
  }

  function render() {
    if (!DATA) return;

    if (!brand) {
      crumb.innerHTML = '<span aria-current="step">1 · Brand</span><em>›</em><span>2 · Model</span><em>›</em><span>3 · Generation</span>';
      stage.innerHTML = '<div class="garage__grid garage__grid--brands">' + DATA.map(function (b, i) {
        var logo = LOGOS[b.k];
        var mark = logo
          ? '<img class="garage__logo" src="' + logo + '" alt="' + esc(b.n) + '" loading="lazy">'
          : '<span class="garage__wordmark">' + esc(b.n) + '</span>';
        var gens = b.m.reduce(function (n, m) { return n + m.g.length; }, 0);
        var stocked = 0;
        b.m.forEach(function (m) { m.g.forEach(function (g) { if (KNOWS_STOCK && STOCK[tagOf(g)]) stocked++; }); });
        var right = KNOWS_STOCK ? (stocked > 0 ? stocked + ' in stock' : '&mdash;') : gens;
        return '<button class="garage__i garage__i--brand' + (KNOWS_STOCK && stocked === 0 ? ' is-empty' : '') +
          '" data-brand="' + i + '" aria-label="' + esc(b.n) + '">' +
          mark + '<span class="garage__sub"><span>' + b.m.length + ' models</span><b>' + right + '</b></span></button>';
      }).join('') + '</div>';
      return;
    }

    if (!model) {
      crumb.innerHTML = '<button data-back="brand">' + esc(brand.n) + '</button><em>›</em>' +
        '<span aria-current="step">2 · Model</span><em>›</em><span>3 · Generation</span>';
      stage.innerHTML = '<div class="garage__grid">' + brand.m.map(function (m, i) {
        var c = countFor(m.g);
        var empty = KNOWS_STOCK && c === 0;
        var right = KNOWS_STOCK ? (c > 0 ? c + ' in stock' : '&mdash;') : m.g.length;
        return '<button class="garage__i' + (empty ? ' is-empty' : '') + '" data-model="' + i + '">' +
          '<span class="garage__name">' + esc(m.n) + '</span>' +
          '<span class="garage__sub"><span>' + m.g.length + ' gens</span><b>' + right + '</b></span></button>';
      }).join('') + '</div>';
      return;
    }

    crumb.innerHTML = '<button data-back="brand">' + esc(brand.n) + '</button><em>›</em>' +
      '<button data-back="model">' + esc(model.n) + '</button><em>›</em>' +
      '<span aria-current="step">3 · Generation</span>';
    var gens = model.g.filter(function (g) { return HIDE_EMPTY ? hasParts(g) : true; });

    if (!gens.length) {
      stage.innerHTML = '<p class="mono muted wrap" style="padding-block:26px">Nothing listed for this model yet. ' +
        '<a href="' + ENQUIRY + '" style="color:var(--cobalt-soft)">Ask us to source it</a>.</p>';
      return;
    }

    stage.innerHTML = '<div class="garage__grid garage__grid--wide">' + gens.map(function (g) {
      var tag = tagOf(g);
      var stocked = hasParts(g);
      var href = stocked
        ? '/collections/' + BASE + '/' + tag
        : ENQUIRY + '?vehicle=' + encodeURIComponent(brand.n + ' ' + model.n + ' ' + g[0]);
      return '<a class="garage__i' + (stocked ? '' : ' is-empty') + '" href="' + href + '" data-pick="' + esc(g[0]) + '">' +
        '<span class="garage__name">' + esc(g[0]) + '</span>' +
        '<span class="garage__sub"><span>' + esc(g[1]) + '</span><b>' +
        (stocked ? 'View parts' : 'Ask us') + '</b></span></a>';
    }).join('') + '</div>';
  }

  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-brand]');
    if (b) { brand = DATA[+b.getAttribute('data-brand')]; model = null; render(); return; }

    var m = e.target.closest('[data-model]');
    if (m) { model = brand.m[+m.getAttribute('data-model')]; render(); return; }

    var back = e.target.closest('[data-back]');
    if (back) {
      if (back.getAttribute('data-back') === 'brand') { brand = null; model = null; }
      else { model = null; }
      render(); return;
    }

    var pick = e.target.closest('[data-pick]');
    if (pick) {
      save({ brand: brand.n, model: model.n, gen: pick.getAttribute('data-pick') });
      paintBar();
    }
  });

  var fill = document.querySelector('[data-garage-fill]');
  if (fill && !fill.value) {
    var sv = saved();
    if (sv) fill.value = sv.brand + ' ' + sv.model + ' ' + sv.gen;
  }

  fetch(root.getAttribute('data-src'))
    .then(function (r) { return r.json(); })
    .then(function (d) { DATA = d; render(); })
    .catch(function () {
      stage.innerHTML = '<p class="mono muted wrap" style="padding-block:24px">Vehicle list unavailable. <a href="/pages/contact" style="color:var(--cobalt-soft)">Send us your VIN</a> instead.</p>';
    });
})();
